import { useState, useMemo } from 'react'
import dayjs from 'dayjs'
import { useGetInvoiceList, useGetInvoiceListV2 } from 'api/invoice/query'

import toRupiah from 'helpers/toRupiah'
import tranformDateToSlash from 'helpers/tranformDateToSlash'

const useListInvoice = () => {
  // Use params as state for query parameters
  const [params, setParams] = useState({
    invoice_status: "menunggu",
    _limit: 30,
    date: null
  })

  // Use the API hook for fetching paginated data
  const {
    data: infiniteData,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage,
    status,
    isFetching
  } = useGetInvoiceListV2({ params })

  // Transform data in a single useMemo hook for efficiency
  const mappedData = useMemo(() => {
    if (status !== 'success' || !infiniteData?.pages) return []

    // Process all pages in one go - follow the pattern from list-training.js
    return infiniteData.pages.flatMap((page, pageIndex) => {
      
      // Get invoice items based on the API response structure
      const invoices = page?.data?.data || [];
      
      if (!Array.isArray(invoices) || invoices.length === 0) {
        return [];
      }
      
      return invoices.map((item, idx) => {
        // Calculate the continuous index across pages
        const globalIndex = pageIndex > 0
          ? params._limit * pageIndex + idx + 1
          : idx + 1

        // Flag the last element for intersection observer
        const isLastElement = pageIndex === infiniteData.pages.length - 1 &&
          idx === invoices.length - 1

        // Return the mapped data in the final format needed by the table
        return {
          id: globalIndex,
          company_name: item?.company?.name || "-",
          tagihan: toRupiah(item?.total_amount),
          periode: item?.invoice_period_formatted,
          tanggal_diputihkan: item?.invoice_date ? dayjs(tranformDateToSlash(item.invoice_date)).format("DD-MM-YYYY") : "-",
          tanggal_pembayaran: item?.paid_at ? dayjs(item.paid_at).format("DD-MM-YYYY") : "-",
          remaining_days: item?.remaining_days || 0,
          invoice_number: item?.invoice_number,
          jatuh_tempo: item?.due_date ? dayjs(tranformDateToSlash(item.due_date)).format("DD-MM-YYYY") : "-",
          invoice_id: item?.id,
          isLastElement,
          fullData: {
            ...item,
            globalIndex,
            isLastElement
          }
        }
      })
    })
  }, [infiniteData, params._limit])

  const COLLUMNS = useMemo(() => ([
    {
      Header: 'No',
      accessor: 'id', // accessor is the "key" in the data
    },
    {
      Header: 'Nomor Invoice',
      accessor: 'invoice_number', // accessor is the "key" in the data
    },
    {
      Header: 'Tagihan',
      accessor: 'tagihan', // accessor is the "key" in the data
    },
    {
      Header: 'Periode',
      accessor: 'periode', // accessor is the "key" in the data
    },
    params.invoice_status === "menunggu" ?
      {
        Header: 'Jatuh Tempo',
        accessor: 'jatuh_tempo', // accessor is the "key" in the data
      }
      : params.invoice_status === "lunas" ?
        {
          Header: 'Tanggal Pembayaran',
          accessor: 'tanggal_pembayaran', // accessor is the "key" in the data
        }
        : params.invoice_status === "diputihkan" ?
          {
            Header: 'Tanggal Diputihkan',
            accessor: 'tanggal_diputihkan', // accessor is the "key" in the data
          }
          : null
  ]), [params.invoice_status, mappedData])

  return {
    data: mappedData,
    COLLUMNS,
    setParams,
    status,
    isFetching,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage,
    params
  }
}

export default useListInvoice